/**
 * Polices disponibles pour l'éditeur de pages, partagées entre le back-office
 * (sélecteur), le rendu public (balise <link>) et la validation serveur
 * (`server/pageSections.ts`) — une seule liste, pas de duplication qui
 * dérive.
 */
export interface FontOption {
  /** Clé stockée dans `VisitorConfig.typography.fontFamily`. */
  key: string;
  label: string;
  /** Valeur CSS `font-family`, avec repli générique. */
  cssFamily: string;
  /** Nom de famille tel qu'attendu par l'API Google Fonts (espaces -> +). */
  googleFontsName: string;
}

export const FONT_OPTIONS: FontOption[] = [
  { key: 'inter', label: 'Inter (par défaut)', cssFamily: "'Inter', sans-serif", googleFontsName: 'Inter' },
  { key: 'poppins', label: 'Poppins', cssFamily: "'Poppins', sans-serif", googleFontsName: 'Poppins' },
  { key: 'montserrat', label: 'Montserrat', cssFamily: "'Montserrat', sans-serif", googleFontsName: 'Montserrat' },
  { key: 'roboto', label: 'Roboto', cssFamily: "'Roboto', sans-serif", googleFontsName: 'Roboto' },
  { key: 'nunito', label: 'Nunito', cssFamily: "'Nunito', sans-serif", googleFontsName: 'Nunito' },
  { key: 'lora', label: 'Lora', cssFamily: "'Lora', serif", googleFontsName: 'Lora' },
  { key: 'playfair_display', label: 'Playfair Display', cssFamily: "'Playfair Display', serif", googleFontsName: 'Playfair Display' },
  { key: 'merriweather', label: 'Merriweather', cssFamily: "'Merriweather', serif", googleFontsName: 'Merriweather' },
];

const BY_KEY = new Map(FONT_OPTIONS.map((f) => [f.key, f]));

export function getFontOption(key: string | undefined): FontOption | undefined {
  if (!key) return undefined;
  return BY_KEY.get(key);
}

export function isValidFontKey(key: string): boolean {
  return BY_KEY.has(key);
}

/** URL Google Fonts CSS2 pour une police donnée, à poser dans un <link rel="stylesheet">. */
export function googleFontsUrl(option: FontOption): string {
  const family = option.googleFontsName.replace(/ /g, '+');
  return `https://fonts.googleapis.com/css2?family=${family}:wght@400;600;700&display=swap`;
}
